import { post } from './common';

interface SuggestionsOptions {
  OptionsType: string;
  Query: string;
}

const getSuggestions = (payload: SuggestionsOptions): Promise<Response> => {
    return post('/Services/SuggestSelectionService.asmx/GetSuggestions', payload);
};

export { getSuggestions };
